var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    transform: "translate(0 0.204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "facebook-logo_1_",
    "data-name": "facebook-logo (1)",
    transform: "translate(15.296 8.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M133.072,7.876V5.8a4.564,4.564,0,0,1,.043-.722,1.4,1.4,0,0,1,.2-.5.8.8,0,0,1,.5-.343,3.53,3.53,0,0,1,.912-.095h2.071V0h-3.311a5.389,5.389,0,0,0-4.128,1.363A5.744,5.744,0,0,0,128.1,5.382V7.876h-2.48v4.142h2.48V24.035h4.974V12.018h3.31l.438-4.142Z",
    transform: "translate(-125.619)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    transform: "translate(0 -0.204)",
    fill: "none",
    stroke: "#9c9ca8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/Facebook Icon.70ecf682da49a023134105e306e63188.svg";
export { ForwardRef as ReactComponent };